import type { GeneratedRecordListSort } from '@/entities/GeneratedRecord';
import type { OrderOption, SortSelection } from '@/shared/lib';

interface GeneratedRecordOrderOption extends OrderOption {
  sort: 'createdAt' | 'name' | 'sequence';
  order: 'asc' | 'desc';
}

/**
 * The record has no effective date, so "Arquivo mais recente/antigo" follow the creation, and the
 * code in the "Registros Gerados" column is the sequence inside one lineage.
 */
export const GENERATED_RECORD_ORDER_OPTIONS: readonly GeneratedRecordOrderOption[] = [
  { label: 'Arquivo mais recente', sort: 'createdAt', order: 'desc' },
  { label: 'Arquivo mais antigo', sort: 'createdAt', order: 'asc' },
  { label: 'Ordem alfabética crescente', sort: 'name', order: 'asc' },
  { label: 'Ordem alfabética decrescente', sort: 'name', order: 'desc' },
  { label: 'Do menor para o maior', sort: 'sequence', order: 'asc' },
  { label: 'Do maior para o menor', sort: 'sequence', order: 'desc' },
];

export const NO_GENERATED_RECORD_SORT: Readonly<SortSelection> = { sort: '', order: '' };

export function toGeneratedRecordListSort(
  selection: SortSelection
): GeneratedRecordListSort | undefined {
  const option = GENERATED_RECORD_ORDER_OPTIONS.find(
    ({ sort, order }) => sort === selection.sort && order === selection.order
  );
  return option ? `${option.sort}_${option.order}` : undefined;
}

export function parseGeneratedRecordSort(sort: unknown, order: unknown): SortSelection {
  if (typeof sort !== 'string' || typeof order !== 'string') return { ...NO_GENERATED_RECORD_SORT };
  return toGeneratedRecordListSort({ sort, order })
    ? { sort, order }
    : { ...NO_GENERATED_RECORD_SORT };
}
